


























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import TheHomePageContactSectionSvg from './TheHomePageContactSectionSvg.vue';
import axios from 'axios';


@Component({
    components: {
        TheHomePageContactSectionSvg
    }
})
export default class TheHomePageContactSection extends Vue {
   form = {
       email: "",
       message: ""
   }

   async postContact() {
        try {
            await axios.post('/', {
                email: this.form.email,
                message: this.form.message
            });
        }
        catch(err) {
            alert(err.message);
        }
    }
}
